var map = {
	"./kaizerChiefs/basketball-category-icon-white.png": "a92f",
	"./kaizerChiefs/basketball-icon-white.png": "e385",
	"./kaizerChiefs/cricket-category-icon-white.png": "860d",
	"./kaizerChiefs/cricket-icon-white.png": "2f52",
	"./kaizerChiefs/football-category-icon-white.png": "6a7b",
	"./kaizerChiefs/football-icon-white.png": "16b4",
	"./kaizerChiefs/home-manager-icon-white.png": "4d15",
	"./kaizerChiefs/home-predict-icon-white.png": "253d",
	"./kaizerChiefs/home-rugby-icon-white.png": "9472",
	"./kaizerChiefs/home-soccer-icon-white.png": "bcc6",
	"./kaizerChiefs/menu-badge-icon-white.png": "ee7b",
	"./kaizerChiefs/menu-home-icon-white.png": "893a",
	"./kaizerChiefs/menu-lock-icon-white.png": "5e75",
	"./kaizerChiefs/menu-predict-icon-white.png": "8ead",
	"./kaizerChiefs/menu-question-mark-icon-white.png": "daac",
	"./kaizerChiefs/menu-tandcs-icon-white.png": "8cff",
	"./kaizerChiefs/menu-trophy-icon-white.png": "dad2",
	"./kaizerChiefs/minus-icon-white.png": "2b18",
	"./kaizerChiefs/olympics-icon-white.png": "1e04",
	"./kaizerChiefs/plus-icon-white.png": "50d0",
	"./kaizerChiefs/rugby-category-icon-white.png": "37a3",
	"./kaizerChiefs/rugby-icon-white.png": "c59d",
	"./vodacom/basketball-category-icon-white.png": "b49c",
	"./vodacom/basketball-icon-white.png": "c7fb",
	"./vodacom/cricket-category-icon-white.png": "1f97",
	"./vodacom/cricket-icon-white.png": "5055",
	"./vodacom/football-category-icon-white.png": "64ee",
	"./vodacom/home-manager-icon-white.png": "745c",
	"./vodacom/home-predict-icon-white.png": "c3d8",
	"./vodacom/home-rugby-icon-white.png": "6a48",
	"./vodacom/home-soccer-icon-white.png": "f2e2",
	"./vodacom/menu-badge-icon-white.png": "3ba3",
	"./vodacom/menu-home-icon-white.png": "ac0e",
	"./vodacom/menu-lock-icon-white.png": "928c",
	"./vodacom/menu-predict-icon-white.png": "09aa",
	"./vodacom/menu-question-mark-icon-white.png": "cba6",
	"./vodacom/menu-tandcs-icon-white.png": "fc58",
	"./vodacom/menu-trophy-icon-white.png": "76d9",
	"./vodacom/minus-icon-white.png": "1f0f",
	"./vodacom/olympics-icon-white.png": "b44e",
	"./vodacom/plus-icon-white.png": "6f5d",
	"./vodacom/rugby-category-icon-white.png": "946d",
	"./vodacom/rugby-icon-white.png": "2c6f",
	"./vodacom/soccer-icon-white.png": "0524"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ef1";